import { ExtractedDataSnapshot, ExtractedRow, ExtractedValue } from '../../models/extracted-values';
import { ForderungspositionCompletionDto } from '../../models/interfaces';
import { formatDate } from '../../utils/Date.utils';

const DEFAULT_ART = 'AMBULANT';

export function mapForderungspositionen(
  snapshot: ExtractedDataSnapshot,
): ForderungspositionCompletionDto[] {
  return (snapshot.tables['forderungen'] ?? []).map(mapRow);
}

function mapRow(row: ExtractedRow): ForderungspositionCompletionDto {
  const { rowData } = row;
  return {
    art: row.class ?? DEFAULT_ART,
    beschreibung: (rowData['forderungen_beschreibung']?.value as string) ?? '',
    datumVon: formatDate(rowData['forderungen_von']?.value as string),
    datumBis: formatDate(rowData['forderungen_bis']?.value as string),
    originalBetrag: toAmount(rowData['forderungen_betrag']?.value),
  };
}

function toAmount(value: ExtractedValue | undefined): number {
  const amount = Number(value);
  return Number.isFinite(amount) ? amount : 0;
}
